import React, { useState } from 'react';

/**
 * Component สำหรับแสดง payment proof แบบ lazy loading
 * แสดงเป็น icon ก่อน และให้กดดูได้เมื่อต้องการ
 */
const PaymentProofViewer = ({ 
  paymentProofUrl, 
  alt = 'Payment Proof',
  className = '',
  showLabel = true,
  size = 'md' // sm, md, lg
}) => {
  const [showImage, setShowImage] = useState(false);
  const [imageError, setImageError] = useState(false);

  if (!paymentProofUrl) {
    return null;
  }

  const sizeClasses = {
    sm: 'w-8 h-8 text-sm',
    md: 'w-12 h-12 text-lg',
    lg: 'w-16 h-16 text-xl'
  };

  const iconSizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  return (
    <div className={`${className}`}>
      {!showImage ? (
        <div className="flex items-center gap-2">
          <button
            onClick={() => setShowImage(true)}
            className={`
              ${sizeClasses[size]}
              bg-blue-50 hover:bg-blue-100 
              border-2 border-blue-300 hover:border-blue-400
              rounded-lg 
              flex items-center justify-center
              transition-all duration-200
              cursor-pointer
              shadow-sm hover:shadow-md
            `}
            title="คลิกเพื่อดูหลักฐานการโอน"
          >
            <svg 
              className={iconSizeClasses[size]} 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
              style={{ color: '#3B82F6' }}
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" 
              />
            </svg>
          </button>
          {showLabel && (
            <button
              onClick={() => setShowImage(true)}
              className="text-sm text-blue-600 hover:text-blue-700 hover:underline font-medium cursor-pointer"
            >
              ดูหลักฐานการโอน
            </button>
          )}
        </div>
      ) : (
        <div className="space-y-2">
          {imageError ? (
            <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-center">
              <p className="text-sm text-red-600">ไม่สามารถโหลดรูปภาพได้</p>
              <button
                onClick={() => {
                  setImageError(false);
                  setShowImage(true);
                }}
                className="mt-2 text-xs text-red-600 hover:text-red-700 underline"
              >
                ลองอีกครั้ง
              </button>
            </div>
          ) : (
            <div className="relative">
              <img 
                src={paymentProofUrl} 
                alt={alt}
                className="max-w-full max-h-96 rounded-lg border border-gray-300 shadow-md object-contain"
                onError={() => setImageError(true)}
                loading="lazy"
              />
              <button
                onClick={() => {
                  setShowImage(false);
                  setImageError(false);
                }}
                className="absolute top-2 right-2 bg-black bg-opacity-50 hover:bg-opacity-70 text-white rounded-full p-1.5 transition-all"
                title="ปิด"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          )}
          <button
            onClick={() => {
              setShowImage(false);
              setImageError(false);
            }}
            className="text-sm text-gray-600 hover:text-gray-700 underline"
          >
            ซ่อนรูปภาพ
          </button>
        </div>
      )}
    </div>
  );
};

export default PaymentProofViewer;










